/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateVisitPrescriptionsDoctorApiInContract,
  CreateVisitPrescriptionsDoctorApiOutContract,
  EncounterUrlDoctorApiOutContract,
  ErrorApiOutContract,
  ErrorDescription,
  PrescriptionDoctorApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Retrieves all prescriptions for a specific patient.
 */
export const getPatientsPatientIdPrescriptions = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PrescriptionDoctorApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/prescriptions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdPrescriptionsInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/prescriptions`
    ] as const;
    }

export const getGetPatientsPatientIdPrescriptionsQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/prescriptions`
    ] as const;
    }

    
export const getGetPatientsPatientIdPrescriptionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionsInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>> = ({ signal }) => getPatientsPatientIdPrescriptions(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>
export type GetPatientsPatientIdPrescriptionsInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific patient.
 */

export function useGetPatientsPatientIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionsInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all prescriptions for a specific patient.
 */
export const prefetchGetPatientsPatientIdPrescriptionsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPrescriptionsInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPrescriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>> = ({ signal }) => getPatientsPatientIdPrescriptions(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>
export type GetPatientsPatientIdPrescriptionsQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptions<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptions<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptions<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific patient.
 */

export function useGetPatientsPatientIdPrescriptions<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionsQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all prescriptions for a specific patient.
 */
export const prefetchGetPatientsPatientIdPrescriptionsQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPrescriptionsQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPrescriptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>> = ({ signal }) => getPatientsPatientIdPrescriptions(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>
export type GetPatientsPatientIdPrescriptionsSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific patient.
 */

export function useGetPatientsPatientIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionsSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdPrescriptionsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPrescriptionsInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>> = ({ signal }) => getPatientsPatientIdPrescriptions(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPrescriptionsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>
export type GetPatientsPatientIdPrescriptionsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific patient.
 */

export function useGetPatientsPatientIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPrescriptionsSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieves all prescriptions for a specific visit.
 */
export const getVisitsVisitIdPrescriptions = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PrescriptionDoctorApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/prescriptions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdPrescriptionsInfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/visits/${visitId}/prescriptions`
    ] as const;
    }

export const getGetVisitsVisitIdPrescriptionsQueryKey = (visitId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/visits/${visitId}/prescriptions`
    ] as const;
    }

    
export const getGetVisitsVisitIdPrescriptionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdPrescriptionsInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>> = ({ signal }) => getVisitsVisitIdPrescriptions(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdPrescriptionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>
export type GetVisitsVisitIdPrescriptionsInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific visit.
 */

export function useGetVisitsVisitIdPrescriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdPrescriptionsInfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all prescriptions for a specific visit.
 */
export const prefetchGetVisitsVisitIdPrescriptionsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdPrescriptionsInfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdPrescriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdPrescriptionsQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>> = ({ signal }) => getVisitsVisitIdPrescriptions(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdPrescriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>
export type GetVisitsVisitIdPrescriptionsQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdPrescriptions<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptions<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptions<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific visit.
 */

export function useGetVisitsVisitIdPrescriptions<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdPrescriptionsQueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all prescriptions for a specific visit.
 */
export const prefetchGetVisitsVisitIdPrescriptionsQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdPrescriptionsQueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdPrescriptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdPrescriptionsQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>> = ({ signal }) => getVisitsVisitIdPrescriptions(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdPrescriptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>
export type GetVisitsVisitIdPrescriptionsSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific visit.
 */

export function useGetVisitsVisitIdPrescriptionsSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdPrescriptionsSuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdPrescriptionsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdPrescriptionsInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>> = ({ signal }) => getVisitsVisitIdPrescriptions(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdPrescriptionsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>
export type GetVisitsVisitIdPrescriptionsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all prescriptions for a specific visit.
 */

export function useGetVisitsVisitIdPrescriptionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdPrescriptions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdPrescriptionsSuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientsPatientIdTreaturl = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EncounterUrlDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/treaturl`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdTreaturlInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/treaturl`
    ] as const;
    }

export const getGetPatientsPatientIdTreaturlQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/treaturl`
    ] as const;
    }

    
export const getGetPatientsPatientIdTreaturlInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdTreaturlInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>> = ({ signal }) => getPatientsPatientIdTreaturl(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdTreaturlInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>
export type GetPatientsPatientIdTreaturlInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdTreaturlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdTreaturlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdTreaturlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdTreaturlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdTreaturlInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdTreaturlInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdTreaturlInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdTreaturlQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdTreaturlQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>> = ({ signal }) => getPatientsPatientIdTreaturl(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdTreaturlQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>
export type GetPatientsPatientIdTreaturlQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdTreaturl<TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdTreaturl<TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdTreaturl<TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdTreaturl<TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdTreaturlQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdTreaturlQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdTreaturlQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdTreaturlSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdTreaturlQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>> = ({ signal }) => getPatientsPatientIdTreaturl(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdTreaturlSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>
export type GetPatientsPatientIdTreaturlSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdTreaturlSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdTreaturlSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdTreaturlSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdTreaturlSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdTreaturlSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdTreaturlSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdTreaturlInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>> = ({ signal }) => getPatientsPatientIdTreaturl(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdTreaturlSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>
export type GetPatientsPatientIdTreaturlSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdTreaturlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdTreaturlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdTreaturlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdTreaturlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdTreaturlSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVisitsVisitIdTreaturl = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EncounterUrlDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/treaturl`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdTreaturlInfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/visits/${visitId}/treaturl`
    ] as const;
    }

export const getGetVisitsVisitIdTreaturlQueryKey = (visitId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/visits/${visitId}/treaturl`
    ] as const;
    }

    
export const getGetVisitsVisitIdTreaturlInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdTreaturlInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>> = ({ signal }) => getVisitsVisitIdTreaturl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdTreaturlInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>
export type GetVisitsVisitIdTreaturlInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdTreaturlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdTreaturlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdTreaturlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdTreaturlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdTreaturlInfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsVisitIdTreaturlInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdTreaturlInfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdTreaturlQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdTreaturlQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>> = ({ signal }) => getVisitsVisitIdTreaturl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdTreaturlQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>
export type GetVisitsVisitIdTreaturlQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdTreaturl<TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdTreaturl<TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdTreaturl<TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdTreaturl<TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdTreaturlQueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetVisitsVisitIdTreaturlQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdTreaturlQueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdTreaturlSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdTreaturlQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>> = ({ signal }) => getVisitsVisitIdTreaturl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdTreaturlSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>
export type GetVisitsVisitIdTreaturlSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdTreaturlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdTreaturlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdTreaturlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdTreaturlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdTreaturlSuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdTreaturlSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdTreaturlInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>> = ({ signal }) => getVisitsVisitIdTreaturl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdTreaturlSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>
export type GetVisitsVisitIdTreaturlSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdTreaturlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdTreaturlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdTreaturlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVisitsVisitIdTreaturlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdTreaturl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdTreaturlSuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Creates a ScriptSure encounter for the visit and returns the encounter URL.
 */
export const getVisitsVisitIdEncounterUrl = (
    visitId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<EncounterUrlDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/encounterUrl`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVisitsVisitIdEncounterUrlInfiniteQueryKey = (visitId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/visits/${visitId}/encounterUrl`
    ] as const;
    }

export const getGetVisitsVisitIdEncounterUrlQueryKey = (visitId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/visits/${visitId}/encounterUrl`
    ] as const;
    }

    
export const getGetVisitsVisitIdEncounterUrlInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdEncounterUrlInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>> = ({ signal }) => getVisitsVisitIdEncounterUrl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdEncounterUrlInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>
export type GetVisitsVisitIdEncounterUrlInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdEncounterUrlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Creates a ScriptSure encounter for the visit and returns the encounter URL.
 */

export function useGetVisitsVisitIdEncounterUrlInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdEncounterUrlInfiniteQueryOptions(visitId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Creates a ScriptSure encounter for the visit and returns the encounter URL.
 */
export const prefetchGetVisitsVisitIdEncounterUrlInfiniteQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdEncounterUrlInfiniteQueryOptions(visitId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdEncounterUrlQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdEncounterUrlQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>> = ({ signal }) => getVisitsVisitIdEncounterUrl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(visitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdEncounterUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>
export type GetVisitsVisitIdEncounterUrlQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdEncounterUrl<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrl<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>,
          TError,
          Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrl<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Creates a ScriptSure encounter for the visit and returns the encounter URL.
 */

export function useGetVisitsVisitIdEncounterUrl<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdEncounterUrlQueryOptions(visitId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Creates a ScriptSure encounter for the visit and returns the encounter URL.
 */
export const prefetchGetVisitsVisitIdEncounterUrlQuery = async <TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, visitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetVisitsVisitIdEncounterUrlQueryOptions(visitId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetVisitsVisitIdEncounterUrlSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdEncounterUrlQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>> = ({ signal }) => getVisitsVisitIdEncounterUrl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdEncounterUrlSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>
export type GetVisitsVisitIdEncounterUrlSuspenseQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdEncounterUrlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Creates a ScriptSure encounter for the visit and returns the encounter URL.
 */

export function useGetVisitsVisitIdEncounterUrlSuspense<TData = Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdEncounterUrlSuspenseQueryOptions(visitId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVisitsVisitIdEncounterUrlSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorApiOutContract>(visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVisitsVisitIdEncounterUrlInfiniteQueryKey(visitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>> = ({ signal }) => getVisitsVisitIdEncounterUrl(visitId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVisitsVisitIdEncounterUrlSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>
export type GetVisitsVisitIdEncounterUrlSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetVisitsVisitIdEncounterUrlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVisitsVisitIdEncounterUrlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Creates a ScriptSure encounter for the visit and returns the encounter URL.
 */

export function useGetVisitsVisitIdEncounterUrlSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>>, TError = void | ErrorApiOutContract>(
 visitId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getVisitsVisitIdEncounterUrl>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVisitsVisitIdEncounterUrlSuspenseInfiniteQueryOptions(visitId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Creates prescriptions for a visit without placing an order.
 */
export const postVisitsVisitIdPrescriptionsItemsBulk = (
    visitId: string,
    createVisitPrescriptionsDoctorApiInContract: CreateVisitPrescriptionsDoctorApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<CreateVisitPrescriptionsDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/visits/${encodeURIComponent(String(visitId))}/prescriptions/items/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createVisitPrescriptionsDoctorApiInContract, signal
    },
      options);
    }
  


export const getPostVisitsVisitIdPrescriptionsItemsBulkMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdPrescriptionsItemsBulk>>, TError,{visitId: string;data: CreateVisitPrescriptionsDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdPrescriptionsItemsBulk>>, TError,{visitId: string;data: CreateVisitPrescriptionsDoctorApiInContract}, TContext> => {

const mutationKey = ['postVisitsVisitIdPrescriptionsItemsBulk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVisitsVisitIdPrescriptionsItemsBulk>>, {visitId: string;data: CreateVisitPrescriptionsDoctorApiInContract}> = (props) => {
          const {visitId,data} = props ?? {};

          return  postVisitsVisitIdPrescriptionsItemsBulk(visitId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVisitsVisitIdPrescriptionsItemsBulkMutationResult = NonNullable<Awaited<ReturnType<typeof postVisitsVisitIdPrescriptionsItemsBulk>>>
    export type PostVisitsVisitIdPrescriptionsItemsBulkMutationBody = CreateVisitPrescriptionsDoctorApiInContract
    export type PostVisitsVisitIdPrescriptionsItemsBulkMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Creates prescriptions for a visit without placing an order.
 */
export const usePostVisitsVisitIdPrescriptionsItemsBulk = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVisitsVisitIdPrescriptionsItemsBulk>>, TError,{visitId: string;data: CreateVisitPrescriptionsDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVisitsVisitIdPrescriptionsItemsBulk>>,
        TError,
        {visitId: string;data: CreateVisitPrescriptionsDoctorApiInContract},
        TContext
      > => {

      const mutationOptions = getPostVisitsVisitIdPrescriptionsItemsBulkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postPrescriptionsEvents = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/prescriptions/events`, method: 'POST', signal
    },
      options);
    }
  


export const getPostPrescriptionsEventsMutationOptions = <TError = ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPrescriptionsEvents>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postPrescriptionsEvents>>, TError,void, TContext> => {

const mutationKey = ['postPrescriptionsEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPrescriptionsEvents>>, void> = () => {
          

          return  postPrescriptionsEvents(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPrescriptionsEventsMutationResult = NonNullable<Awaited<ReturnType<typeof postPrescriptionsEvents>>>
    
    export type PostPrescriptionsEventsMutationError = ErrorApiOutContract

    export const usePostPrescriptionsEvents = <TError = ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPrescriptionsEvents>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPrescriptionsEvents>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPrescriptionsEventsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    